var getQuery = require('./getQuery');

    /**
     * Checks if query string contains parameter.
     */
    function contains(url, paramName) {
        var regex = new RegExp('(\\?|&)'+ paramName +'=', 'g'); //matches `?param=` or `&param=`
        return regex.test(getQuery(url));
    }

    module.exports = contains;




//////////////////
// WEBPACK FOOTER
// ./~/mout/queryString/contains.js
// module id = 1650
// module chunks = 0 1 2